export default {"src":"/_next/static/media/thunderstorm_with_rain.5ac7aad3.svg","height":156,"width":156};